﻿/** Leilão entre técnicos humanos (usado pelo servidor online e pela interface). */

export type SituacaoLeilao = 'aberto' | 'vendido' | 'sem-lances' | 'cancelado' | 'falhou';

export interface Leilao {
  id: number;
  jogadorId: number;
  jogador: string;
  posicao: string;
  overall: number;
  idade: number;
  vendedorId: number;
  precoInicial: number;
  /** maior lance (ou o preço inicial enquanto não há lances) */
  lance: number;
  lanceClubeId: number | null;
  terminaEm: number;
  situacao: SituacaoLeilao;
  motivo?: string;
}

export const LANCE_MINIMO_PASSO = 100_000;

/** Menor lance aceito: o preço inicial se ainda não há lances; senão o lance atual + max(100 mil, 5%). */
export function lanceMinimo(l: Leilao): number {
  if (l.lanceClubeId === null) return l.precoInicial;
  return l.lance + Math.max(LANCE_MINIMO_PASSO, Math.round(l.lance * 0.05));
}
